import React, { Component } from 'react';
import { LoginForReason } from './Login';
import { useParams } from "react-router-dom";

function RequestForm(props) {
  const { topic } = useParams();
  return <RequestOnTopic {...props} topic={topic} />;
}

class RequestOnTopic extends Component {
  render() {
    if (!this.props.isLoggedIn) {
      return (<LoginForReason setLoggedInFlag={this.props.setLoggedInFlag} reason={this.props.topic}/>);
    }

    const topicMap = {
      deltaoffers: '01 Delta Offers & Pricing',
      effluxoffers: '02 Efflux Offers & Pricing'
    };

    const topicTitle = topicMap[this.props.topic] || '00 Generic Topic';

    return (
      <div className="request-form">
      <h6>Topic: {topicTitle}</h6>
        <h2 id="first">Request page is currently under construction. Thanks for your patience.</h2>
      </div>
    );
  }
}

export default RequestForm;